import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResumeModal } from '../../new-contract-large-accounts.model';
import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-new-contract-modal-resume',
  templateUrl: './new-contract-modal-resume.component.html',
  styleUrls: ['./new-contract-modal-resume.component.scss']
})
export class NewContractModalResumeComponent {
  public tab1Offer = false;
  public tab1Campaign = false;
  public tabHiring = false;
  public tab2Campaign = false;
  public isUserSpanish = true;

  constructor(
    private dialogRef: MatDialogRef<NewContractModalResumeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResumeModal,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    this.isUserSpanish = this.auth.getUserData().country === 'ES';
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public toggletab1Offer(): void {
    this.tab1Offer = !this.tab1Offer;
  }

  public toggletab1Campaign(): void {
    this.tab1Campaign = !this.tab1Campaign;
  }

  public toggleTabHiring(): void {
    this.tabHiring = !this.tabHiring;
  }

  public toggletab2Campaign(): void {
    this.tab2Campaign = !this.tab2Campaign;
  }
}
